import React from 'react'
import { useState } from 'react'
import { Box, Button, Center, Flex, Image, Input, useToast, VStack } from '@chakra-ui/react'
import axios from 'axios'
import {useNavigate} from 'react-router-dom'
const Login = () => {

  const initialvalues={ email: "", password: "" }

  const [values, setValues] = useState(initialvalues)

  const toast = useToast();
  const navigate=useNavigate()


  const handleChange = (e) => {

    setValues({ ...values, [e.target.name]: e.target.value });

  }

  const handleSubmit = () => {
    if( values.email!==""  && values.password!==""){
      axios({
        method: 'post',
        url: `http://localhost:5003/users/login`,
        data:values
    })
    .then((res)=>{
      localStorage.setItem("token",res.data.token);
      res.data.msg?toast({
        title: 'Login Sucessfull',
        description: "Redirecting To Home Page",
        position:'top',
        status: 'success',
        duration: 2000,
        isClosable: true,
      }):
      toast({
        title: 'Login Faild',
        status: 'error',
        position:'top',
        duration: 2000,
        isClosable: true,
      })
      //  console.log(res.data);
    res.data.msg==="Login successfull"?(res.data.role==='user'?navigate("/"):navigate('/admin_dashboard')):navigate("/login");
    })
    .catch((err)=>{
      toast({
        title: 'Something Went Wrong!',
        status: 'error',
        position:'top',
        duration: 2000,
        isClosable: true,
      })

    })
    .finally(setValues(initialvalues))
    }else{
      toast({
        title: 'Enter All Details!',
        status: 'error',
        position:'top',
        duration: 2000,
        isClosable: true,
      })
    }
  }

  return (
    <Flex>
      <Box bgColor="#11256b" h="100vh" display={{base:"none",lg:"block",xl:"block"}}> <Image src="https://www.tooezlife.com/images/bg/tooezlifehomeservice.png" w={{md: "150px",lg:"300px",xl:"700px"}} h={{md: "50px",lg:"200px",xl:"400px"}} mt="200px" /></Box>

      <Box bgColor="#ededed" w="60%" >
      <Image src="/images/GS.png"  w={{ base:"40px",md: "60px",lg:"80px",xl:"100px"}} h={{base:"30px",md: "40px",lg:"40px",xl:"60px"}} mt="50px"  ml={{base:"200px",md: "300px",lg:"300px",xl:"400px"}}/>
        <Box  w={{ base:"250px",md: "400px",lg:"400px",xl:"450px"}} h="500px" mt="20px" ml={{ base:"80px",md: "100px",lg:"200px",xl:"270px"}} boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px;" bgColor="#ECFAFA">
            <VStack spacing="30px"  h="350px" w={{ base:"220px",md: "350px",lg:"350px",xl:"400px"}} m="auto">
              <Input type="email" placeholder='Email' onChange={handleChange} name="email" value={values.email} h="50px" mt="60px" borderColor="black"/>
              <Input type="password" placeholder='Password' onChange={handleChange} name="password" value={values.password} h="50px" borderColor="black"/>
              <Center><Button onClick={handleSubmit} h="50px" w={{ base:"200px",md: "200px",lg:"200px",xl:"250px"}}  bgColor="#F048B8">Login</Button></Center>
            </VStack>
        </Box>
      </Box>
    </Flex>
  )
}

export default Login

